import Vue from 'vue'
import Vuex from 'vuex'
import cms from './modules/cms'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    cms
  }
})
